import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './index.css';
import { useMemo } from 'react';

interface IProps {
  value: string;
  onChange: (playRate: string) => void;
  list: { value: string; text: string }[];
}

const StepSlider: React.FC<IProps> = ({ value, onChange, list }) => {
  const stepsCount = useMemo(
    () => list.findIndex((item) => item.value === value),
    [value, list]
  );
  const handleChangePlayRate = (val: number | number[]) => {
    if (typeof val !== 'number') return;
    onChange(list[val].value);
  };

  return (
    <>
      <Slider
        className={`play-rate-slider ${
          stepsCount === 0
            ? 'active-first'
            : stepsCount === list.length - 1
            ? 'active-last'
            : ''
        }`}
        min={0}
        max={list.length - 1}
        value={stepsCount}
        onChange={handleChangePlayRate}
      />
      <div className="relative h-5 mt-2.75 text-mx-tertiary text-3.5">
        {list.map((item, index) => (
          <div
            className={`absolute ${
              index === 0
                ? ''
                : index === list.length - 1
                ? 'translate-x--100%'
                : 'translate-x--50%'
            }`}
            style={{ left: `${(index / (list.length - 1)) * 100}%` }}
            key={item.value}
            onClick={() => {
              handleChangePlayRate(index);
            }}
          >
            {item.text}
          </div>
        ))}
      </div>
    </>
  );
};

export default StepSlider;
